// extracted by css-extract-rspack-plugin
export default {"do":"do-_4XxtJ","dont":"dont-tMZKLt"};